<template>
	<div class="container-fluid pbot-75" v-cloak>

		<div class="row mt-5">
			<div class="col-12">
				<h1 class="text-center text-decoration-underline">ContentBASE Affiliate Promo Content</h1>
				<p class="sub-paragraph text-center">Click the preview images to access all full size promo content for a bundle.</p>
				<p class="sub-paragraph text-center">Click the name links to view the bundle product page.</p>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col-12">
				<div class="promo-controls-shell">
					<div class="promo-control-card">
						<span class="promo-control-card__eyebrow">Preview Size</span>
						<label class="promo-checkbox-control">
							<input v-model="largePreviews" type="checkbox">
							<span class="promo-checkbox-control__indicator" aria-hidden="true"></span>
							<span class="promo-checkbox-control__label">Larger Preview Images</span>
						</label>
					</div>

					<div class="promo-control-card">
						<span class="promo-control-card__eyebrow">Bundle Type</span>
						<div class="promo-binary-switch" role="group" aria-label="Promo bundle type">
							<button
								type="button"
								class="promo-binary-switch__button"
								:class="clsBundleTypeSwitchButton('paid')"
								:aria-pressed="selectedBundleType == 'paid'"
								@click="selectBundleType('paid')">Paid Bundles</button>
							<button
								type="button"
								class="promo-binary-switch__button"
								:class="clsBundleTypeSwitchButton('free')"
								:aria-pressed="selectedBundleType == 'free'"
								:disabled="freeBundlesDisabled"
								@click="selectBundleType('free')">Free Bundles</button>
						</div>
					</div>

					<label class="promo-control-card promo-control-card--select" for="select-super-bundle-filter">
						<span class="promo-control-card__eyebrow">Bundle Scope</span>
						<select id="select-super-bundle-filter" class="form-control promo-scope-select" v-model.number="selectedSuperBundleID">
							<option :value="0">All Bundles</option>
							<option v-for="superBundleFilter in superBundleFilters" :key="superBundleFilter.id" :value="superBundleFilter.id">{{getSuperBundleOptionText(superBundleFilter)}}</option>
						</select>
					</label>
				</div>
			</div>
		</div>

		<div class="row mt-4" v-if="selectedSuperBundle != null">
			<div class="col-12">
				<div class="promo-filter-summary">
					<span class="promo-filter-summary__text">
						Showing only bundles included in
						<a :href="selectedSuperBundle.url" target="_blank">{{selectedSuperBundle.name}}</a>.
						{{selectedSuperBundleVisibleCountText}}
					</span>
					<button type="button" class="promo-filter-summary__clear" @click="clearSuperBundleFilter()">Show all bundles</button>
				</div>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col-12">
				<h2 class="text-center">{{getTableHeader()}}</h2>
				<p v-if="selectedCanvaBundles.length == 0" class="text-center regular-paragraph promo-empty-state">No promo bundles match the current filters.</p>
				<table class="table-promo-overview" v-else>
					<thead>
						<tr>
							<th>ID</th>
							<th>Promo Image Previews</th>
							<th>Name</th>
							<th>Social Media</th>
							<th>Category</th>
							<th>Nr. Promo Images</th>
							<th>Nr. Credits</th>
							<th>Discount</th>
							<th>Nr. Templates</th>
							<th>Dimensions</th>
							<th>Published On</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="canvaBundle in selectedCanvaBundles" :key="canvaBundle.id">
							<td><span>{{canvaBundle.id}}</span></td>
							<td><a class="promo-view-link" :href="getPromoViewUrl(canvaBundle)" target="_blank"><img :class="clsPreviewSize()" :src="getPreviewImageUrl(canvaBundle)" /></a></td>
							<td><a class="bundle-view-link" :href="canvaBundle.url" target="_blank">{{canvaBundle.name}}</a></td>
							<td><span>{{getSocialMediaName(canvaBundle)}}</span></td>
							<td><span>{{getBundleCategoryName(canvaBundle)}}</span></td>
							<td><span>{{canvaBundle.nrImages}}</span></td>
							<td><span>{{canvaBundle.nrCredits}}</span></td>
							<td><span :class="clsDiscountInfo(canvaBundle)">{{getDiscountInfo(canvaBundle)}}</span></td>
							<td><span>{{canvaBundle.nrTemplates}}</span></td>
							<td><span>{{getDimensions(canvaBundle)}}</span></td>
							<td><span>{{formatDateTime(canvaBundle.createdOn)}}</span></td>
						</tr>
					</tbody>
					<tfoot>
						<tr>
							<th>ID</th>
							<th>Promo Image Previews</th>
							<th>Name</th>
							<th>Social Media</th>
							<th>Category</th>
							<th>Nr. Promo Images</th>
							<th>Nr. Credits</th>
							<th>Discount</th>
							<th>Nr. Templates</th>
							<th>Dimensions</th>
							<th>Published On</th>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>

	</div>
</template>




<script>
	import { mixinAxios } from '@/js/shared/VueMixins.js';
	import { countDecimals, rangeCap, toFixedNumber, toYMD } from '@/js/shared/utils';

	export default {
		mixins: [mixinAxios],
		data: () => ({
			canvaBundles : [],
			superBundleFilters : [],
			selectedSuperBundleID : 0,
			selectedBundleType : 'paid',
			largePreviews : false
		}),
		created() {
			this.getCanvaBundles();
			this.getSuperBundleFilters();
		},
		mounted() {
		},
		methods: {
			getCanvaBundles() {
				return this.mixinAxios().get('/api/guest/GetCanvaBundles').then((resCanvaBundles) => {
					var result        = resCanvaBundles.data ?? {};
					this.canvaBundles = result.canvaBundles ?? [];
				});
			},
			getSuperBundleFilters() {
				return this.mixinAxios().get('/api/guest/super-bundles/GetPromoSuperBundleFilters').then((resSuperBundleFilters) => {
					this.superBundleFilters = resSuperBundleFilters.data ?? [];
				});
			},
			clearSuperBundleFilter() {
				this.selectedSuperBundleID = 0;
			},
			selectBundleType(bundleType) {
				if ((bundleType == 'free') && this.freeBundlesDisabled)
				{
					return;
				}

				this.selectedBundleType = bundleType;
			},
			getPromoViewUrl(bundle) {
				return `/promo/${bundle.id}/`;
			},
			getPreviewImageUrl(bundle) {
				return bundle.images[0].img500Url;
			},
			getSocialMediaName(bundle) {
				return bundle.socialMediaTypeName ?? '';
			},
			getBundleCategory(bundle) {
				return bundle.bundleCategory ?? {};
			},
			getBundleCategoryName(bundle) {
				return this.getBundleCategory(bundle).name ?? '';
			},
			getSuperBundleOptionText(superBundleFilter) {
				var nrBundles = superBundleFilter.nrBundles ?? superBundleFilter.includedBundleIDs?.length ?? 0;
				var label = superBundleFilter.name ?? '';

				if (this.showSuperBundleLanguageDescriptions && (superBundleFilter.languageDescription ?? '').length > 0)
				{
					label += ` / ${superBundleFilter.languageDescription}`;
				}

				if (nrBundles > 0)
				{
					label += ` / ${nrBundles} bundle${(nrBundles == 1) ? '' : 's'}`;
				}

				return label;
			},
			getDiscountPercentage(bundle) {
				var discounted = (bundle.activeDiscountPeriod != null);
				var percentage = (discounted)
					? 100 - ((bundle.activeDiscountPeriod.nrCredits / bundle.nrCredits) * 100)
					: 0;
				var nrDecs = rangeCap(countDecimals(percentage), 0, 0) ?? 0;
				return (percentage != null) ? `${toFixedNumber(percentage, nrDecs)}%` : '';
			},
			_getDiscountInfo(bundle) {
				return this.getDiscountPercentage(bundle);
			},
			getDiscountInfo(bundle) {
				var discounted = (bundle.activeDiscountPeriod != null);
				var nrDays     = (discounted) ? bundle.activeDiscountPeriod.nrCredits : null;
				var percentage = (discounted) ? this._getDiscountInfo(bundle) : null;


				return (discounted)
					? `${nrDays} Credits (${percentage})`
					: '-';
			},
			getDimensions(bundle) {
				return bundle.dimensionDescription;
			},
			clsDiscountInfo(bundle) {
				return {
					'bold-red' : this.bundleIsDiscounted(bundle)
				};
			},
			bundleIsDiscounted(bundle) {
				return (bundle.activeDiscountPeriod != null);
			},
			clsPreviewSize() {
				return {
					'preview-image-large' : this.largePreviews,
					'preview-image-small' : !this.largePreviews
				};
			},
			clsBundleTypeSwitchButton(bundleType) {
				return {
					'promo-binary-switch__button--active' : this.selectedBundleType == bundleType
				};
			},
			getTableHeader() {
				var superBundle = this.selectedSuperBundle;
				return (superBundle != null)
					? `${this.selectedBundleTypeTitle} - ${superBundle.name}`
					: this.selectedBundleTypeTitle;
			},
			formatDateTime(dateTime) {
				return toYMD(new Date(dateTime));
			}
		},
		computed: {
			showSuperBundleLanguageDescriptions() {
				var distinctLanguageDescriptions = this.superBundleFilters
					.map((x) => x.languageDescription ?? '')
					.filter((x) => x.length > 0)
					.filter((value, index, array) => array.indexOf(value) == index);

				return (distinctLanguageDescriptions.length > 1);
			},
			selectedSuperBundle() {
				return this.superBundleFilters.find((x) => x.id == this.selectedSuperBundleID) ?? null;
			},
			freeBundlesDisabled() {
				return (this.selectedSuperBundle != null);
			},
			filteredCanvaBundles() {
				var selectedSuperBundle = this.selectedSuperBundle;

				if (selectedSuperBundle == null)
				{
					return this.canvaBundles;
				}

				var includedBundleIDs = new Set(selectedSuperBundle.includedBundleIDs ?? []);
				return this.canvaBundles.filter((x) => includedBundleIDs.has(x.id));
			},
			paidCanvaBundles() {
				return this.filteredCanvaBundles.filter((x => x.nrCredits > 0));
			},
			freeCanvaBundles() {
				return this.filteredCanvaBundles.filter((x => x.nrCredits == 0));
			},
			selectedCanvaBundles() {
				return (this.selectedBundleType == 'free')
					? this.freeCanvaBundles
					: this.paidCanvaBundles;
			},
			selectedBundleTypeTitle() {
				return (this.selectedBundleType == 'free')
					? 'Free Bundles'
					: 'Paid Bundles';
			},
			selectedSuperBundleVisibleCountText() {
				var nrVisibleBundles = this.selectedCanvaBundles.length;

				return (nrVisibleBundles == 1)
					? '1 bundle currently matches.'
					: `${nrVisibleBundles.toLocaleString()} bundles currently match.`;
			}
		},
		watch: {
			selectedSuperBundleID(newSelectedSuperBundleID) {
				if (newSelectedSuperBundleID > 0)
				{
					this.selectedBundleType = 'paid';
				}
			}
		}
	}
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}

	/* TABLE */

	.table-promo-overview {
		margin:auto;
		width:95%;
		border-collapse:collapse;
		border-spacing:0;
		border-radius:0.5rem;
		overflow:hidden;
	}

	.table-promo-overview td, .table-promo-overview th {
		border:1px solid #ddd;
		padding:8px;
		text-align:center;
	}

	.table-promo-overview th {
		font-weight:bold;
		padding-top: 12px;
		padding-bottom: 12px;
		text-align: left;
		background-color: rgb(67,56,202);
		color: white;
		text-align:center;
	}

	.table-promo-overview tr:nth-child(even) {
		background-color: #f2f2f2;
	}

	.pbot-75 {
		padding-bottom:50px;
	}

	.preview-image-large {
		max-width:300px;
	}

	.preview-image-small {
		max-width:100px;
	}

	.bundle-view-link {
		font-weight:bold;
	}

	.promo-view-link img {
		border:3px solid transparent;
	}

	.promo-view-link img:hover {
		border:3px solid rgb(67,56,202);
	}

	.bundle-view-link:hover {
		text-decoration:underline;
	}

	.bold-red {
		font-weight:bold;
		color:red;
	}

	.promo-empty-state {
		margin-top:20px;
	}

	/* TABLE */




	/* CONTROLS */

	.promo-controls-shell {
		max-width: 1180px;
		margin: 0 auto;
		display: grid;
		grid-template-columns: minmax(220px, 0.95fr) minmax(280px, 1.05fr) minmax(360px, 1.35fr);
		gap: 1rem;
		align-items: stretch;
	}

	.promo-control-card {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 0.7rem;
		min-height: 108px;
		padding: 1rem 1.15rem;
		border: 1px solid rgba(148, 163, 184, 0.22);
		border-radius: 1.35rem;
		background:
			radial-gradient(circle at top right, rgba(191, 219, 254, 0.18), transparent 30%),
			#ffffff;
		box-shadow: 0px 20px 40px -32px rgba(15, 23, 42, 0.45);
	}

	.promo-control-card--select {
		cursor: default;
	}

	.promo-control-card__eyebrow {
		font-size: 0.78rem;
		font-weight: 800;
		letter-spacing: 0.12em;
		text-transform: uppercase;
		color: #64748b;
	}

	.promo-checkbox-control {
		position: relative;
		display: inline-flex;
		align-items: center;
		gap: 0.8rem;
		font-size: 1rem;
		font-weight: 700;
		color: #172554;
		cursor: pointer;
		user-select: none;
	}

	.promo-checkbox-control input {
		position: absolute;
		opacity: 0;
		pointer-events: none;
	}

	.promo-checkbox-control__indicator {
		position: relative;
		flex: 0 0 auto;
		width: 1.4rem;
		height: 1.4rem;
		border: 1.5px solid #c7d2fe;
		border-radius: 0.45rem;
		background: #eef2ff;
		transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
	}

	.promo-checkbox-control__indicator::after {
		content: "";
		position: absolute;
		left: 0.36rem;
		top: 0.16rem;
		width: 0.38rem;
		height: 0.72rem;
		border-right: 2px solid #ffffff;
		border-bottom: 2px solid #ffffff;
		transform: rotate(45deg) scale(0);
		transform-origin: center;
		transition: transform 0.18s ease;
	}

	.promo-checkbox-control input:checked + .promo-checkbox-control__indicator {
		border-color: transparent;
		background: linear-gradient(135deg, #4338ca 0%, #7c3aed 100%);
		box-shadow: 0px 14px 24px rgba(79, 70, 229, 0.24);
	}

	.promo-checkbox-control input:checked + .promo-checkbox-control__indicator::after {
		transform: rotate(45deg) scale(1);
	}

	.promo-checkbox-control:hover .promo-checkbox-control__indicator {
		transform: translateY(-1px);
	}

	.promo-checkbox-control__label {
		line-height: 1.4;
	}

	.promo-binary-switch {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 0.35rem;
		padding: 0.3rem;
		border: 1px solid rgba(79, 70, 229, 0.14);
		border-radius: 999px;
		background: #eef2ff;
	}

	.promo-binary-switch__button {
		border: 0;
		border-radius: 999px;
		padding: 0.78rem 1rem;
		background: transparent;
		font-size: 0.95rem;
		font-weight: 800;
		color: #475569;
		transition: transform 0.18s ease, color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
	}

	.promo-binary-switch__button:hover {
		transform: translateY(-1px);
		color: #172554;
	}

	.promo-binary-switch__button:disabled {
		cursor: not-allowed;
		transform: none;
	}

	.promo-binary-switch__button:disabled:not(.promo-binary-switch__button--active) {
		color: #94a3b8;
	}

	.promo-binary-switch__button--active {
		background: linear-gradient(135deg, #4338ca 0%, #7c3aed 100%);
		color: #ffffff;
		box-shadow: 0px 14px 24px rgba(79, 70, 229, 0.24);
	}

	.promo-scope-select {
		min-height: 3.15rem;
		border: 1px solid #d4deeb;
		border-radius: 0.95rem;
		background: #f8fbff;
		font-weight: 600;
		color: #172554;
		box-shadow: none;
	}

	.promo-scope-select:focus {
		border-color: rgba(79, 70, 229, 0.4);
		box-shadow: 0 0 0 0.2rem rgba(79, 70, 229, 0.12);
	}

	.promo-filter-summary {
		max-width: 1180px;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		gap: 0.85rem 1.25rem;
		padding: 0.95rem 1.15rem;
		border: 1px solid rgba(79, 70, 229, 0.14);
		border-radius: 1rem;
		background: #eef2ff;
	}

	.promo-filter-summary__text {
		font-size: 0.98rem;
		font-weight: 700;
		color: #4338ca;
	}

	.promo-filter-summary__clear {
		border: 0;
		padding: 0;
		background: transparent;
		font-size: 0.92rem;
		font-weight: 800;
		color: #4338ca;
		text-decoration: underline;
		text-underline-offset: 0.16rem;
	}

	.promo-filter-summary__clear:hover {
		color: #312e81;
	}

	/* CONTROLS */




	/* OTHER */

	h1 {
		font-size:36px;
		font-weight:600;
		line-height:52px;
		letter-spacing:0.03em;
		margin:0;
	}

	h2 {
		font-size:35px;
		font-weight:700;
		line-height:48px;
		letter-spacing:0.03em;
		margin:0;
	}

	.sub-paragraph {
		font-size:26px;
		font-weight:normal;
		line-height:28px;
		letter-spacing:0.03em;
		margin:10px 0px 0px 0px;
	}

	.regular-paragraph {
		font-size:22px;
		font-weight:normal;
		line-height:23px;
		letter-spacing:0.03em;
		margin:0;
	}

	/* OTHER */



	/* MEDIA QUERIES */

	@media screen and (max-width: 1199px)
	{
		.promo-controls-shell {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.promo-control-card--select {
			grid-column: 1 / -1;
		}
	}

	@media screen and (max-width: 767px)
	{
		.promo-controls-shell {
			grid-template-columns: minmax(0, 1fr);
		}

		.promo-control-card--select {
			grid-column: auto;
		}

		.promo-filter-summary {
			justify-content: center;
			text-align: center;
		}
	}

</style>
